import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { createForm, FormType, subformComponentProviders } from 'ngx-sub-form';
import { PoreFrac } from 'src/app/perivis/models/poreFrac.model';
import { CirculatedKickLiquidIPP, InternalPressureProfileType } from '../../models/internal-pressure-profile.model';
import { UomQuantityInput } from '../../uom-quantity-input/uom-quantity-input-component';
import { UserUnitsModel } from 'src/app/core/components/user-units/user-units.model';
import { WellComponent } from 'src/app/wellbore-inputs/components/well-configuration/models';
import { InfluxFracDepthBaseComponent } from '../gas-influx/influx-frac-depth-base/influx-frac-depth-base.component';

interface CirculatedKickLiquidIppForm {
  type: InternalPressureProfileType.LIQUIDKICK;
  influxDepth: UomQuantityInput;
  liquidDensity: UomQuantityInput;
  kickVolume: UomQuantityInput;
  kickIntensity: UomQuantityInput;
  maxMudWeight: UomQuantityInput;
  fractureDepth: UomQuantityInput;
  fractureGradient: UomQuantityInput;
  fractureMarginOfError: UomQuantityInput;
  drillPipeOd: UomQuantityInput;
}

@Component({
  selector: 'app-circulated-kick-liquid-ipp',
  templateUrl: './circulated-kick-liquid-ipp.component.html',
  providers: subformComponentProviders(CirculatedKickLiquidIppComponent),
  standalone: false
})
export class CirculatedKickLiquidIppComponent implements AfterViewInit {

  @Input() currentString: any;
  @Input() nextStringMudWeight: number;
  @Input() smallestPipeId: number;
  @Input() fracPressures: PoreFrac[];
  @Input() userUnits: UserUnitsModel;
  @Input() influxDepthRange: { min: number, max: number };
  @Input() tubulars: WellComponent[];
  @Input() fractureDepthDefault: number;

  @ViewChild(InfluxFracDepthBaseComponent) influxFracDepthBase!: InfluxFracDepthBaseComponent;

  public form = createForm<CirculatedKickLiquidIPP, CirculatedKickLiquidIppForm>(this, {
    formType: FormType.SUB,
    formControls: {
      type: new UntypedFormControl(InternalPressureProfileType.LIQUIDKICK),
      influxDepth: new UntypedFormControl(null),
      liquidDensity: new UntypedFormControl(null),
      kickVolume: new UntypedFormControl(null),
      kickIntensity: new UntypedFormControl(null),
      maxMudWeight: new UntypedFormControl(null),
      fractureDepth: new UntypedFormControl(null),
      fractureGradient: new UntypedFormControl(null),
      fractureMarginOfError: new UntypedFormControl(null),
      drillPipeOd: new UntypedFormControl(null)
    },
    toFormGroup: (obj: CirculatedKickLiquidIPP | null): CirculatedKickLiquidIppForm | null => {
      if (!obj) {
        return null;
      }

      return {
        type: obj.type,
        influxDepth: { control: obj.influxDepth },
        liquidDensity: { control: obj.liquidDensity },
        kickVolume: { control: obj.kickVolume },
        kickIntensity: { control: obj.kickIntensity },
        maxMudWeight: { control: obj.maxMudWeight },
        fractureDepth: { control: obj.fractureDepth },
        fractureGradient: { control: obj.fractureGradient },
        fractureMarginOfError: { control: obj.fractureMarginOfError },
        drillPipeOd: { control: obj.drillPipeOd }
      }
    },
    fromFormGroup: (formValue: CirculatedKickLiquidIppForm): CirculatedKickLiquidIPP | null => {
      const { influxDepth, liquidDensity, kickVolume, kickIntensity, maxMudWeight, fractureDepth, fractureGradient, fractureMarginOfError, drillPipeOd, ...commonValues } = formValue;
      return {
        influxDepth: +influxDepth?.control,
        liquidDensity: +liquidDensity?.control,
        kickVolume: +kickVolume?.control,
        kickIntensity: +kickIntensity?.control,
        maxMudWeight: +maxMudWeight?.control,
        fractureDepth: +fractureDepth?.control,
        fractureGradient: +fractureGradient?.control,
        fractureMarginOfError: +fractureMarginOfError?.control,
        drillPipeOd: +drillPipeOd?.control,
        ...commonValues
      }
    }
  });

  ngAfterViewInit(): void {
    this.influxFracDepthBase.getEmwDefaultFrac(this.influxDepthRange.max, this.influxFracDepthBase.fractureDepthDefault, false, false);
  }
}
